import classNames from 'classnames'
import { DefineComponentProps } from 'utils'
import './styles/virtual-table-th-column.scss'

export type TableColumnProps<T = any> = {
  type?: 'expand' | 'normal'
  prop: string
  label: string
  align?: 'left' | 'center' | 'right'
  width?: string
  minWidth?: string
  maxWidth?: string
  sortable?: boolean | 'custom'
  sortMethod?: (a: any, b: any) => number
  render?: (data: { row: T; rowIndex: number; cellIndex: number }) => any
  onSortChange?: (sortType: SortType, prop: string) => void
}

export type SortType = 'ascending' | 'descending' | 'normal'

type VirtualTableThCellProps = TableColumnProps & {
  currentSortProp?: string
}

export const VirtualTableThCell = defineComponent<VirtualTableThCellProps>({
  props: DefineComponentProps<
    TableColumnProps & {
      currentSortProp?: string
    }
  >(['type', 'prop', 'label', 'align', 'width', 'minWidth', 'maxWidth', 'sortable', 'sortMethod', 'render', 'onSortChange', 'currentSortProp']),
  setup(props) {
    const sortType = ref<SortType>('normal')

    const handleSort = () => {
      if (!props.sortable) return
      if (sortType.value === 'normal') {
        sortType.value = 'ascending'
      } else if (sortType.value === 'ascending') {
        sortType.value = 'descending'
      } else {
        sortType.value = 'normal'
      }

      props.onSortChange?.(sortType.value, props.prop)
    }

    watch(
      () => props.currentSortProp,
      (val) => {
        if (val !== props.prop) {
          sortType.value = 'normal'
        }
      },
    )

    return () => (
      <div
        class={classNames('virtual-table-th-column', props.align || 'left', {
          'is-sortable': props.sortable,
        })}
        style={{
          '--flex': props.width ? `0 0 ${props.width}` : 1,
        }}
        onClick={handleSort}
      >
        <div class="cell">{props.label}</div>
        {props.sortable && (
          <span class="caret-wrapper">
            <i class={classNames('sort-caret ascending', { active: sortType.value === 'ascending' })}></i>
            <i class={classNames('sort-caret descending', { active: sortType.value === 'descending' })}></i>
          </span>
        )}
      </div>
    )
  },
})
